import { useEffect, useState } from 'react';

import { useRouter } from 'next/router';

import { Dialog } from '@headlessui/react';
import { ArrowTopRightOnSquareIcon, XMarkIcon } from '@heroicons/react/24/outline';

const articles = [
  {
    title: 'Gleec Acquires Komodo Ecosystem',
    href: 'https://komodoplatform.com/en/blog/gleec-acquires-komodo-ecosystem/',
  },
  {
    title: 'CoinDesk: Gleec Buys Komodo’s Cross-Chain DeFi Stack in $23.5M Deal',
    href: 'https://www.coindesk.com/business/2025/12/01/gleec-buys-komodo-s-cross-chain-defi-stack-in-usd23-5m-deal',
  },
];

export const GleecAcquisitionModal = () => {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState(false);

  // Preserve the original announcement's behavior on client-side navigation.
  useEffect(() => {
    setIsOpen(true);
  }, [router.asPath]);

  return (
    <Dialog open={isOpen} onClose={setIsOpen} className='relative z-[20001] font-sans'>
      <div className='fixed inset-0 bg-black/75' aria-hidden='true' />
      <div className='fixed inset-0 overflow-y-auto'>
        <div className='flex min-h-full items-center justify-center p-4'>
          <Dialog.Panel className='relative w-full max-w-xl rounded-2xl bg-slate-900 p-6 text-white shadow-xl sm:p-8'>
            <button
              type='button'
              aria-label='Close announcement'
              onClick={() => setIsOpen(false)}
              className='absolute right-3 top-3 flex h-10 w-10 items-center justify-center rounded-lg text-gray-400 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-300'
            >
              <XMarkIcon className='h-6 w-6' aria-hidden='true' />
            </button>
            <Dialog.Title className='pr-10 font-heading text-2xl font-bold sm:text-3xl'>
              Welcome to Gleec
            </Dialog.Title>
            <Dialog.Description className='mt-5 text-base leading-relaxed text-gray-300'>
              This domain was previously operated by Komodo Platform. Following the acquisition of
              Komodo by Gleec, this website is now part of the Gleec ecosystem and is being
              transitioned to Gleec branding.
            </Dialog.Description>
            <ul className='mt-6 space-y-3'>
              {articles.map((article) => (
                <li key={article.href}>
                  <a
                    href={article.href}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='flex items-center justify-between gap-3 rounded-lg border border-gray-700 bg-gray-800/50 px-4 py-3 text-blue-300 hover:bg-gray-800 hover:text-blue-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-violet-300'
                  >
                    <span>{article.title}</span>
                    <ArrowTopRightOnSquareIcon className='h-5 w-5 shrink-0' aria-hidden='true' />
                  </a>
                </li>
              ))}
            </ul>
            <button
              type='button'
              onClick={() => setIsOpen(false)}
              className='mt-6 w-full rounded-lg bg-gradient-to-r from-[#B8B0FF] to-white px-4 py-3 font-bold text-black hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-violet-300'
            >
              Dismiss
            </button>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};
